<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import toastMixin from '../mixins/toast'
import modalMixin from '../mixins/modal'
import CreateCustomDocField from '../views/create_custom_doc_field/CreateCustomDocField.vue'

export default Vue.extend({
    components: {
        AgGridVue,
        CreateCustomDocField,
    },
    mixins: [toastMixin, modalMixin],
    props: {
        rowData: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
        selectedCustomDocName: {
            required: true,
            type: String,
        },
        selectedCustomDocId: {
            required: true,
            type: [String, Number],
        },
    },
    data() {
        return {
            customDocFieldsColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    width: 100,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.id
                    },
                },
                {
                    field: 'name',
                    headerName: 'Name',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('name', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.name
                    },
                },
                {
                    field: 'description',
                    headerName: 'Description',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('description', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.description
                    },
                },
                {
                    field: 'sort_order',
                    headerName: 'Sort order',
                    sortable: true,
                    editable: true,
                    width: 100,
                    valueSetter: (params) => {
                        params.data.set('sort_order', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.sort_order
                    },
                },
                {
                    field: 'field',
                    headerName: 'Field',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('field', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.field
                    },
                },
                {
                    field: 'length',
                    headerName: 'Length',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('length', params.newValue)
                        params.data.save()
                    },
                    width: 100,
                    valueGetter: (params) => {
                        return params.data.attributes.length
                    },
                },
                {
                    field: 'default_value',
                    headerName: 'Default Value',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('default_value', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.default_value
                    },
                },
                {
                    field: 'type',
                    headerName: 'Type',
                    sortable: true,
                    width: 100,
                    editable: true,
                    cellEditor: 'agSelectCellEditor',
                    cellEditorParams: {
                        values: ['text', 'radio', 'boolean', 'checkbox'],
                        valueListGap: 0,
                    },
                    valueSetter: (params) => {
                        params.data.set('type', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.type
                    },
                },
                {
                    field: 'role',
                    headerName: 'Role',
                    sortable: true,
                    width: 100,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('role', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.role
                    },
                },
                {
                    field: 'user_ids',
                    headerName: 'User Ids',
                    sortable: true,
                    width: 100,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('user_ids', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.user_ids
                    },
                },
                {
                    field: 'required',
                    headerName: 'Required',
                    sortable: true,
                    editable: true,
                    width: 100,
                    cellRenderer: (params) => {
                        let input = document.createElement('input')
                        input.type = 'checkbox'
                        input.checked = params.data.get('required') > 0 ? true : false
                        input.addEventListener('change', (event) => {
                            params.data.set('required', event.target.checked ? 1 : 0)
                            params.data.save()
                        })
                        return input
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.required
                    },
                },
            ],
        }
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
        },
        addCustomDocField() {
            this.showModal('create-custom-doc-field')
        },
    },
})
</script>

<template>
    <div>
        <div class="left">
            <h1>Shows Custom Doc Fields Grid ( {{ this.selectedCustomDocName }} )</h1>
        </div>
        <div class="right">
            <b-button variant="outline-success" @click="addCustomDocField">Add Custom Doc Field</b-button>
        </div>
        <div class="clear"></div>
        <ag-grid-vue class="ag-theme-balham default-grid" :column-defs="customDocFieldsColumnDefs" :row-data="rowData" @grid-ready="onGridReady" />
        <create-custom-doc-field :customeDocId="this.selectedCustomDocId"></create-custom-doc-field>
    </div>
</template>

<style>
@import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
